module.exports = __webpack_public_path__ + "img/img-b56db5.png";